// Top level collection component
if (!customElements.get('component-comparison-chart')) {
  customElements.define('component-comparison-chart', class ComparisonChart extends HTMLElement {
    constructor() {
      super();
      this.props = {
        productTitle: this.dataset.productTitle
      }
    }
    async connectedCallback() {
      this.moveActiveProduct();
    }
    moveActiveProduct() {
      const table = this.querySelector('.js-scrollable');
      const productNameRow = table?.querySelector('tr:nth-child(2)');
      if (!table || !productNameRow) return;

      const productNames = productNameRow.querySelectorAll('td');
      if (!productNames.length) return;

      let activeProduct;
      for (const productName of productNames) {
        if (productName.innerText != '' && this.props.productTitle?.includes(productName.innerText)) {
          activeProduct = productName;
          break;
        }
      }
      if (activeProduct) {
        const activeProductIndex = Array.from(productNames).indexOf(activeProduct);
        const rows = table.querySelectorAll('tr');
        rows.forEach(row => {
          const cellToMove = row.cells?.[activeProductIndex];
          if (!cellToMove || !row.cells?.[1]) return;
          row.deleteCell(activeProductIndex);
          row.insertBefore(cellToMove, row.cells[1]);
        });
      }
    }
  });
}
